
/* styles */
require("!!../../../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-4ba6bf53&scoped=true!sass-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./address.vue")

var Component = require("!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./address.js"),
  /* template */
  require("!!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-4ba6bf53!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./address.vue"),
  /* scopeId */
  "data-v-4ba6bf53",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/modal/aggregate-register/address.vue
// module id = 1894
// module chunks = 1